import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function addThousandSep(intPart: string): string {
  return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/** Formato 1.000.000,00 — per importi con decimali */
export function fmtNum(n: number | string | null | undefined): string {
  const num = Number(n);
  if (n == null || n === '' || isNaN(num)) return '—';
  const fixed = num.toFixed(2);
  const [intPart, decPart] = fixed.split('.');
  return `${addThousandSep(intPart)},${decPart}`;
}

/** Formato 1.000.000 — per prospetti economico-finanziari (senza decimali) */
export function fmtInt(n: number | string | null | undefined): string {
  const num = Number(n);
  if (n == null || n === '' || isNaN(num)) return '—';
  return addThousandSep(String(Math.round(num)));
}
